
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/messaging",
      function () {
        return require("private-next-pages/messaging.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/messaging"])
      });
    }
  